import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@repo/videa-components/src/ui/select';

/** BCP 47 primary subtag to display label mapping */
const LANGUAGE_LABELS: Record<string, string> = {
  en: 'English',
  es: 'Espa\u00f1ol',
};

/** Resolve a BCP 47 tag (e.g. 'en-US') to its display label via primary subtag */
const getLanguageLabel = (code: string): string => {
  const primary = code.split('-')[0] ?? code;
  return (
    LANGUAGE_LABELS[code] ?? LANGUAGE_LABELS[primary] ?? code.toUpperCase()
  );
};

interface LanguageSelectProps {
  /** BCP 47 language tags available for this practice */
  supportedLanguages: string[];
  selectedLanguage: string;
  onSelectedLanguage: (value: string) => void;
}

export const LanguageSelect = ({
  supportedLanguages,
  selectedLanguage,
  onSelectedLanguage,
}: LanguageSelectProps) => {
  // Don't render if only one language is available
  if (supportedLanguages.length <= 1) {
    return null;
  }

  return (
    <Select value={selectedLanguage} onValueChange={onSelectedLanguage}>
      <SelectTrigger>
        <SelectValue placeholder="Language" />
      </SelectTrigger>
      <SelectContent className="vai-overflow-visible vai-z-[10001]">
        {supportedLanguages.map((code) => (
          <SelectItem key={code} value={code}>
            {getLanguageLabel(code)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
